<template>
    <ContainerWithMenu>
        <div class="page-content">
            <div class="row">
                <div class="col-xs-6">
                    <h1 class="h2 margin-bottom-20">{{ $t("views.statement.title") }}</h1>
                </div>
                <StatementFilters @filter-changed="filterChanged" :default-month = "monthFilter" :default-year="yearFilter"/>

            </div>
            <div>
                <div class="panel panel-default">
                    <table class="table">
                        <tbody>
                        <tr>
                            <td>{{ $t("views.statement.orders_title") }}</td>
                            <td>{{ $t("views.statement.quantity_orders") }}
                            </td><td class="col-xs-3 text-right">{{ statementObj.count_total }}</td>
                            <td class="col-xs-3 text-right"></td>
                        </tr>
                        <tr class="active">
                            <td></td>
                            <td>{{ $t("views.statement.gross_price") }}
                            </td><td class="col-xs-3 text-right"></td>
                            <td class="col-xs-3 text-right">€{{ parseFloat(statementObj.price_total).toFixed(2) }}</td>
                        </tr>
                        <tr class="active">
                            <td></td>
                            <td>{{ $t("views.statement.fee_title") }}
                            </td><td class="col-xs-3 text-right"></td>
                            <td class="col-xs-3 text-right">-€{{ (parseFloat(statementObj.price_fee_total)).toFixed(2) }}</td>
                        </tr>
                        <tr>
                            <td colspan="3" class="bold">{{ $t("views.statement.to_pay") }}</td>
                            <td class="col-xs-3 text-right bold">€{{ (parseFloat(statementObj.price_fee_total)).toFixed(2) }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <SpinnerLoader v-show="loading"></SpinnerLoader>

    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";
    import i18n from "../i18n";
    import moment from 'moment'
    import StatementFilters from "../components/statement/StatementFilters";
    import {getStatement} from "../api";
    import SpinnerLoader from "../components/common/SpinnerLoader";

    export default {
    title: i18n.t("views.statement.title"),
    name: "Statement",
    components: {
        ContainerWithMenu,
        StatementFilters,
        SpinnerLoader
    },
    data: function () {
        return {
            loading: false,
            monthFilter: moment().month(),
            yearFilter: moment().year(),
            statementObj: {}
        }
    },
    mounted() {
        this.loadStatementData(this.monthFilter, this.yearFilter)
    },
    methods: {
        async loadStatementData(month, year) {
            this.loading = true;
            try {
                this.statementObj = await getStatement(month, year);
                this.loading = false;
            } catch (e) {
                this.loading = false;
                console.log(e)
            }
        },
        filterChanged(filter){
            this.loadStatementData(filter.month.value, filter.year)
        }
    }
};
</script>
